import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";
import Loading from "./loading.js";

const MySwal = withReactContent(Swal2);

const AppStatistics = (props) => {
  const [loading, setLoading] = useState(true);
  const [rankData, setRankData] = useState([]);
  const [rankDataA, setRankDataA] = useState([]);
  const [rankDataB, setRankDataB] = useState([]);
  const [rankDataC, setRankDataC] = useState([]);
  const [rankDataD, setRankDataD] = useState([]);
  const [rankDataE, setRankDataE] = useState([]);
  const [rankDataF, setRankDataF] = useState([]);
  const [rankUserData, setRankUserData] = useState([]);
  const [rankDepartData, setRankDepartData] = useState([]);
  const [rankDepartDataA, setRankDepartDataA] = useState([]);
  const [rankDepartDataB, setRankDepartDataB] = useState([]);
  const [rankDepartDataC, setRankDepartDataC] = useState([]);
  const [rankDepartDataD, setRankDepartDataD] = useState([]);
  const [rankDepartDataE, setRankDepartDataE] = useState([]);
  const [rankDepartDataF, setRankDepartDataF] = useState([]);
  const [rankSourceData, setRankSourceData] = useState([]);
  const [rankRevenueData, setRankRevenueData] = useState([]);
  const [sourceData, setSourceData] = useState([]);
  const [sourceDataA, setSourceDataA] = useState([]);
  const [sourceDataB, setSourceDataB] = useState([]);
  const [sourceDataC, setSourceDataC] = useState([]);
  const [sourceDataD, setSourceDataD] = useState([]);
  const [sourceDataE, setSourceDataE] = useState([]);
  const [sourceDataF, setSourceDataF] = useState([]);
  const [sources, setSources] = useState([]);
  const [departs, setDeparts] = useState([]);
  const [users, setUsers] = useState([]);
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [day, setDay] = useState(new Date().getDate());
  const [from, setFrom] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [to, setTo] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  };

  const getSources = (data) => {
    var sources = [];

    data.map((el) => {
      sources.push(el.source === null ? "nie określono" : el.source);
    });

    setSources(sources.filter(onlyUnique));
  };

  const getDeparts = (data) => {
    var sources = [];

    data.map((el) => {
      sources.push(el.department === null ? "nie określono" : el.department);
    });

    setDeparts(sources.filter(onlyUnique));
  };

  const getUsers = (data) => {
    var sources = [];

    data.map((el) => {
      sources.push(el.name === null ? "nie określono" : el.name);
    });

    setUsers(sources.filter(onlyUnique));
  };

  const subMonths = (date, month) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() - month));
    return (
      new Date(retDate).getFullYear() +
      "-" +
      (new Date(retDate).getMonth() + 1 < 10
        ? "0" + (new Date(retDate).getMonth() + 1)
        : new Date(retDate).getMonth() + 1) +
      "-" +
      (new Date(retDate).getDate() < 10
        ? "0" + new Date(retDate).getDate()
        : new Date(retDate).getDate())
    );
  };

  const fetchRankData = async () => {
    var body = {
      from: from,
      to: to,
    };

    await fetch("https://apisplit.ftpeople.pl/getLeadsUsersV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        setRankData(data);
        var body = {
          from: subMonths(from, 1),
          to: subMonths(to, 1),
        };

        await fetch("https://apisplit.ftpeople.pl/getLeadsUsersV", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then(async (data) => {
            console.log(data);
            setRankDataA(data);
            var body = {
              from: subMonths(from, 2),
              to: subMonths(to, 2),
            };

            await fetch("https://apisplit.ftpeople.pl/getLeadsUsersV", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then(async (data) => {
                setRankDataB(data);
                var body = {
                  from: subMonths(from, 3),
                  to: subMonths(to, 3),
                };

                await fetch("https://apisplit.ftpeople.pl/getLeadsUsersV", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(body),
                })
                  .then((response) => response.json())
                  .then(async (data) => {
                    setRankDataC(data);
                    var body = {
                      from: subMonths(from, 4),
                      to: subMonths(to, 4),
                    };

                    await fetch("https://apisplit.ftpeople.pl/getLeadsUsersV", {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: secretKey,
                      },
                      body: JSON.stringify(body),
                    })
                      .then((response) => response.json())
                      .then(async (data) => {
                        setRankDataD(data);
                        var body = {
                          from: subMonths(from, 5),
                          to: subMonths(to, 5),
                        };

                        await fetch(
                          "https://apisplit.ftpeople.pl/getLeadsUsersV",
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: secretKey,
                            },
                            body: JSON.stringify(body),
                          }
                        )
                          .then((response) => response.json())
                          .then(async (data) => {
                            setRankDataE(data);
                            var body = {
                              from: subMonths(from, 6),
                              to: subMonths(to, 6),
                            };

                            await fetch(
                              "https://apisplit.ftpeople.pl/getLeadsUsersV",
                              {
                                method: "POST",
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization: secretKey,
                                },
                                body: JSON.stringify(body),
                              }
                            )
                              .then((response) => response.json())
                              .then(async (data) => {
                                setRankDataF(data);
                                fetchSourceData();
                              })
                              .catch((error) => {});
                          })
                          .catch((error) => {});
                      })
                      .catch((error) => {});
                  })
                  .catch((error) => {});
              })
              .catch((error) => {});
          })
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const fetchSourceData = async () => {
    var body = {
      from: from,
      to: to,
    };

    await fetch("https://apisplit.ftpeople.pl/getLeadsSourceV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        setSourceData(data);
        var body = {
          from: subMonths(from, 1),
          to: subMonths(to, 1),
        };

        await fetch("https://apisplit.ftpeople.pl/getLeadsSourceV", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then(async (data) => {
            setSourceDataA(data);
            var body = {
              from: subMonths(from, 2),
              to: subMonths(to, 2),
            };

            await fetch("https://apisplit.ftpeople.pl/getLeadsSourceV", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then(async (data) => {
                setSourceDataB(data);
                var body = {
                  from: subMonths(from, 3),
                  to: subMonths(to, 3),
                };

                await fetch("https://apisplit.ftpeople.pl/getLeadsSourceV", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(body),
                })
                  .then((response) => response.json())
                  .then(async (data) => {
                    setSourceDataC(data);
                    var body = {
                      from: subMonths(from, 4),
                      to: subMonths(to, 4),
                    };

                    await fetch(
                      "https://apisplit.ftpeople.pl/getLeadsSourceV",
                      {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body),
                      }
                    )
                      .then((response) => response.json())
                      .then(async (data) => {
                        setSourceDataD(data);
                        var body = {
                          from: subMonths(from, 5),
                          to: subMonths(to, 5),
                        };

                        await fetch(
                          "https://apisplit.ftpeople.pl/getLeadsSourceV",
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: secretKey,
                            },
                            body: JSON.stringify(body),
                          }
                        )
                          .then((response) => response.json())
                          .then(async (data) => {
                            setSourceDataE(data);
                            var body = {
                              from: subMonths(from, 6),
                              to: subMonths(to, 6),
                            };

                            await fetch(
                              "https://apisplit.ftpeople.pl/getLeadsSourceV",
                              {
                                method: "POST",
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization: secretKey,
                                },
                                body: JSON.stringify(body),
                              }
                            )
                              .then((response) => response.json())
                              .then((data) => {
                                setSourceDataF(data);
                                fetchRankDayData();
                              })
                              .catch((error) => {});
                          })
                          .catch((error) => {});
                      })
                      .catch((error) => {});
                  })
                  .catch((error) => {});
              })
              .catch((error) => {});
          })
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const fetchRankDayData = async () => {
    var body = {
      from: from,
      to: to,
    };

    await fetch("https://apisplit.ftpeople.pl/getLeadsUsersDayV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setRankUserData(data);
        fetchSourceDayData();
      })
      .catch((error) => {});
  };

  const fetchSourceDayData = async () => {
    var body = {
      from: from,
      to: to,
    };

    await fetch("https://apisplit.ftpeople.pl/getAggrSourceDayV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setRankSourceData(data);
        fetchSourceMonthData();
      })
      .catch((error) => {});
  };

  const fetchSourceMonthData = async () => {
    var body = {
      from: from,
      to: to,
    };

    await fetch("https://apisplit.ftpeople.pl/getAggrSourceMonthV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        setRankDepartData(data);
        var body = {
          from: subMonths(from, 1),
          to: subMonths(to, 1),
        };

        await fetch("https://apisplit.ftpeople.pl/getAggrSourceMonthV", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then(async (data) => {
            setRankDepartDataA(data);
            var body = {
              from: subMonths(from, 2),
              to: subMonths(to, 2),
            };

            await fetch("https://apisplit.ftpeople.pl/getAggrSourceMonthV", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then(async (data) => {
                setRankDepartDataB(data);
                var body = {
                  from: subMonths(from, 3),
                  to: subMonths(to, 3),
                };

                await fetch(
                  "https://apisplit.ftpeople.pl/getAggrSourceMonthV",
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body),
                  }
                )
                  .then((response) => response.json())
                  .then(async (data) => {
                    setRankDepartDataC(data);
                    var body = {
                      from: subMonths(from, 4),
                      to: subMonths(to, 4),
                    };

                    await fetch(
                      "https://apisplit.ftpeople.pl/getAggrSourceMonthV",
                      {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body),
                      }
                    )
                      .then((response) => response.json())
                      .then(async (data) => {
                        setRankDepartDataD(data);
                        var body = {
                          from: subMonths(from, 5),
                          to: subMonths(to, 5),
                        };

                        await fetch(
                          "https://apisplit.ftpeople.pl/getAggrSourceMonthV",
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: secretKey,
                            },
                            body: JSON.stringify(body),
                          }
                        )
                          .then((response) => response.json())
                          .then(async (data) => {
                            setRankDepartDataE(data);
                            var body = {
                              from: subMonths(from, 6),
                              to: subMonths(to, 6),
                            };

                            await fetch(
                              "https://apisplit.ftpeople.pl/getAggrSourceMonthV",
                              {
                                method: "POST",
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization: secretKey,
                                },
                                body: JSON.stringify(body),
                              }
                            )
                              .then((response) => response.json())
                              .then((data) => {
                                setRankDepartDataF(data);
                                setLoading(false);
                              })
                              .catch((error) => {});
                          })
                          .catch((error) => {});
                      })
                      .catch((error) => {});
                  })
                  .catch((error) => {});
              })
              .catch((error) => {});
          })
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchRankData();
  };

  useEffect(() => {
    getData();
  }, []);

  const sumCount = (data) => {
    var sum = 0;
    data.map((el) => {
      sum = sum + +el.counter;
    });

    return sum;
  };

  const sumCount2 = (data) => {
    var sum = 0;
    data.map((el) => {
      sum = sum + +el.count;
    });

    return sum;
  };

  const sumValue = (data) => {
    var sum = 0;
    data.map((el) => {
      sum = sum + +el.value;
    });

    return sum;
  };

  const sum = (data, type, source) => {
    var int = 0;
    source
      .filter((el) => el.type === type)
      .map((rank, index) => {
        data
          .filter((el) => el.type === type && el.name === rank.name)
          .map((ex) => {
            int = int + ex.counter;
          });
      });

    return int;
  };

  const sumSource = (data, type, source) => {
    var int = 0;
    source
      .filter((el) => el.company === type)
      .map((rank, index) => {
        data
          .filter((el) => el.company === type && el.source === rank.source)
          .map((ex) => {
            int = int + ex.counter;
          });
      });

    return int;
  };

  const sumDepart = (data, type, source) => {
    var int = 0;
    source
      .filter((el) => el.department === type)
      .map((rank, index) => {
        console.log(rank);
        data
          .filter((el) => el.department === type && el.source === rank.source)
          .map((ex) => {
            console.log(ex);
            int = int + ex.count;
          });
      });

    return int;
  };

  const dataM1 = (
    <>
      {rankData.filter((el) => el.type === "CHF").length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            Ilość leadów CHF przypisanych w zakresie
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość leadów:
              {sumCount(rankData.filter((el) => el.type === "CHF"))}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Handlowiec</th>
              <th>Oddział</th>
              <th>Liczba leadów</th>
              <th>-1 miesiąc</th>
              <th>-2 miesiące</th>
              <th>-3 miesiące</th>
              <th>-4 miesiące</th>
              <th>-5 miesięcy</th>
              <th>-6 miesięcy</th>
            </tr>
            {rankData
              .filter((el) => el.type === "CHF")
              .map((rank, index) => (
                <>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{rank.name}</td>
                    <td>{rank.company}</td>
                    <td>{rank.counter}</td>
                    <td>
                      {rankDataA.filter(
                        (el) => el.type === "CHF" && el.name === rank.name
                      ).length > 0
                        ? rankDataA.filter(
                            (el) => el.type === "CHF" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataB.filter(
                        (el) => el.type === "CHF" && el.name === rank.name
                      ).length > 0
                        ? rankDataB.filter(
                            (el) => el.type === "CHF" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataC.filter(
                        (el) => el.type === "CHF" && el.name === rank.name
                      ).length > 0
                        ? rankDataC.filter(
                            (el) => el.type === "CHF" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataD.filter(
                        (el) => el.type === "CHF" && el.name === rank.name
                      ).length > 0
                        ? rankDataD.filter(
                            (el) => el.type === "CHF" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataE.filter(
                        (el) => el.type === "CHF" && el.name === rank.name
                      ).length > 0
                        ? rankDataE.filter(
                            (el) => el.type === "CHF" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataF.filter(
                        (el) => el.type === "CHF" && el.name === rank.name
                      ).length > 0
                        ? rankDataF.filter(
                            (el) => el.type === "CHF" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                  </tr>
                </>
              ))}
            <tr style={{ fontWeight: "900" }}>
              <td colSpan="3">SUMA</td>
              <td>{sum(rankData, "CHF", rankData)}</td>
              <td>{sum(rankDataA, "CHF", rankData)}</td>
              <td>{sum(rankDataB, "CHF", rankData)}</td>
              <td>{sum(rankDataC, "CHF", rankData)}</td>
              <td>{sum(rankDataD, "CHF", rankData)}</td>
              <td>{sum(rankDataE, "CHF", rankData)}</td>
              <td>{sum(rankDataF, "CHF", rankData)}</td>
            </tr>
          </table>
        </>
      )}
    </>
  );

  const dataS1 = (
    <>
      {sourceData.filter((el) => el.company === "CHF").length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            Ilość leadów CHF przypisanych w zakresie według źródeł
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość leadów:
              {sumCount(sourceData.filter((el) => el.company === "CHF"))}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Źródło</th>
              <th>Liczba leadów</th>
              <th>-1 miesiąc</th>
              <th>-2 miesiące</th>
              <th>-3 miesiące</th>
              <th>-4 miesiące</th>
              <th>-5 miesiecy</th>
              <th>-6 miesięcy</th>
            </tr>
            {sourceData
              .filter((el) => el.company === "CHF")
              .map((rank, index) => (
                <>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{rank.source}</td>
                    <td>{rank.counter}</td>
                    <td>
                      {sourceDataA.filter(
                        (el) =>
                          el.company === "CHF" && rank.source === el.source
                      ).length > 0
                        ? sourceDataA.filter(
                            (el) =>
                              el.company === "CHF" && rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataB.filter(
                        (el) =>
                          el.company === "CHF" && rank.source === el.source
                      ).length > 0
                        ? sourceDataB.filter(
                            (el) =>
                              el.company === "CHF" && rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataC.filter(
                        (el) =>
                          el.company === "CHF" && rank.source === el.source
                      ).length > 0
                        ? sourceDataC.filter(
                            (el) =>
                              el.company === "CHF" && rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataD.filter(
                        (el) =>
                          el.company === "CHF" && rank.source === el.source
                      ).length > 0
                        ? sourceDataD.filter(
                            (el) =>
                              el.company === "CHF" && rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataE.filter(
                        (el) =>
                          el.company === "CHF" && rank.source === el.source
                      ).length > 0
                        ? sourceDataE.filter(
                            (el) =>
                              el.company === "CHF" && rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataF.filter(
                        (el) =>
                          el.company === "CHF" && rank.source === el.source
                      ).length > 0
                        ? sourceDataF.filter(
                            (el) =>
                              el.company === "CHF" && rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                  </tr>
                </>
              ))}
            <tr style={{ fontWeight: "900" }}>
              <td colSpan="2">SUMA</td>
              <td>{sumSource(sourceData, "CHF", sourceData)}</td>
              <td>{sumSource(sourceDataA, "CHF", sourceData)}</td>
              <td>{sumSource(sourceDataB, "CHF", sourceData)}</td>
              <td>{sumSource(sourceDataC, "CHF", sourceData)}</td>
              <td>{sumSource(sourceDataD, "CHF", sourceData)}</td>
              <td>{sumSource(sourceDataE, "CHF", sourceData)}</td>
              <td>{sumSource(sourceDataF, "CHF", sourceData)}</td>
            </tr>
          </table>
        </>
      )}
    </>
  );

  const dataS2 = (
    <>
      {sourceData.filter((el) => el.company === "SKD").length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            Ilość leadów SKD przypisanych w zakresie według źródeł
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość leadów:
              {sumCount(sourceData.filter((el) => el.company === "SKD"))}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Źródło</th>
              <th>Liczba leadów</th>
              <th>-1 miesiąc</th>
              <th>-2 miesiące</th>
              <th>-3 miesiące</th>
              <th>-4 miesiące</th>
              <th>-5 miesiecy</th>
              <th>-6 miesięcy</th>
            </tr>
            {sourceData
              .filter((el) => el.company === "SKD")
              .map((rank, index) => (
                <>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{rank.source}</td>
                    <td>{rank.counter}</td>
                    <td>
                      {sourceDataA.filter(
                        (el) =>
                          el.company === "SKD" && rank.source === el.source
                      ).length > 0
                        ? sourceDataA.filter(
                            (el) =>
                              el.company === "SKD" && rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataB.filter(
                        (el) =>
                          el.company === "SKD" && rank.source === el.source
                      ).length > 0
                        ? sourceDataB.filter(
                            (el) =>
                              el.company === "SKD" && rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataC.filter(
                        (el) =>
                          el.company === "SKD" && rank.source === el.source
                      ).length > 0
                        ? sourceDataC.filter(
                            (el) =>
                              el.company === "SKD" && rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataD.filter(
                        (el) =>
                          el.company === "SKD" && rank.source === el.source
                      ).length > 0
                        ? sourceDataD.filter(
                            (el) =>
                              el.company === "SKD" && rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataE.filter(
                        (el) =>
                          el.company === "SKD" && rank.source === el.source
                      ).length > 0
                        ? sourceDataE.filter(
                            (el) =>
                              el.company === "SKD" && rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataF.filter(
                        (el) =>
                          el.company === "SKD" && rank.source === el.source
                      ).length > 0
                        ? sourceDataF.filter(
                            (el) =>
                              el.company === "SKD" && rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                  </tr>
                </>
              ))}
            <tr style={{ fontWeight: "900" }}>
              <td colSpan="2">SUMA</td>
              <td>{sumSource(sourceData, "SKD", sourceData)}</td>
              <td>{sumSource(sourceDataA, "SKD", sourceData)}</td>
              <td>{sumSource(sourceDataB, "SKD", sourceData)}</td>
              <td>{sumSource(sourceDataC, "SKD", sourceData)}</td>
              <td>{sumSource(sourceDataD, "SKD", sourceData)}</td>
              <td>{sumSource(sourceDataE, "SKD", sourceData)}</td>
              <td>{sumSource(sourceDataF, "SKD", sourceData)}</td>
            </tr>
          </table>
        </>
      )}
    </>
  );

  const dataS3 = (
    <>
      {sourceData.filter((el) => el.company === "WIBOR").length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            Ilość leadów WIBOR przypisanych w zakresie według źródeł
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość leadów:
              {sumCount(sourceData.filter((el) => el.company === "WIBOR"))}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Źródło</th>
              <th>Liczba leadów</th>
              <th>-1 miesiąc</th>
              <th>-2 miesiące</th>
              <th>-3 miesiące</th>
              <th>-4 miesiące</th>
              <th>-5 miesiecy</th>
              <th>-6 miesięcy</th>
            </tr>
            {sourceData
              .filter((el) => el.company === "WIBOR")
              .map((rank, index) => (
                <>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{rank.source}</td>
                    <td>{rank.counter}</td>
                    <td>
                      {sourceDataA.filter(
                        (el) =>
                          el.company === "WIBOR" && rank.source === el.source
                      ).length > 0
                        ? sourceDataA.filter(
                            (el) =>
                              el.company === "WIBOR" &&
                              rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataB.filter(
                        (el) =>
                          el.company === "WIBOR" && rank.source === el.source
                      ).length > 0
                        ? sourceDataB.filter(
                            (el) =>
                              el.company === "WIBOR" &&
                              rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataC.filter(
                        (el) =>
                          el.company === "WIBOR" && rank.source === el.source
                      ).length > 0
                        ? sourceDataC.filter(
                            (el) =>
                              el.company === "WIBOR" &&
                              rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataD.filter(
                        (el) =>
                          el.company === "WIBOR" && rank.source === el.source
                      ).length > 0
                        ? sourceDataD.filter(
                            (el) =>
                              el.company === "WIBOR" &&
                              rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataE.filter(
                        (el) =>
                          el.company === "WIBOR" && rank.source === el.source
                      ).length > 0
                        ? sourceDataE.filter(
                            (el) =>
                              el.company === "WIBOR" &&
                              rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {sourceDataF.filter(
                        (el) =>
                          el.company === "WIBOR" && rank.source === el.source
                      ).length > 0
                        ? sourceDataF.filter(
                            (el) =>
                              el.company === "WIBOR" &&
                              rank.source === el.source
                          )[0].counter
                        : "brak danych"}
                    </td>
                  </tr>
                </>
              ))}
            <tr style={{ fontWeight: "900" }}>
              <td colSpan="2">SUMA</td>
              <td>{sumSource(sourceData, "WIBOR", sourceData)}</td>
              <td>{sumSource(sourceDataA, "WIBOR", sourceData)}</td>
              <td>{sumSource(sourceDataB, "WIBOR", sourceData)}</td>
              <td>{sumSource(sourceDataC, "WIBOR", sourceData)}</td>
              <td>{sumSource(sourceDataD, "WIBOR", sourceData)}</td>
              <td>{sumSource(sourceDataE, "WIBOR", sourceData)}</td>
              <td>{sumSource(sourceDataF, "WIBOR", sourceData)}</td>
            </tr>
          </table>
        </>
      )}
    </>
  );

  const dataM2 = (
    <>
      {rankData.filter((el) => el.type === "SKD").length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            Ilość leadów SKD przypisanych w zakresie
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość leadów:
              {sumCount(rankData.filter((el) => el.type === "SKD"))}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Handlowiec</th>
              <th>Oddział</th>
              <th>Liczba leadów</th>
              <th>-1 miesiąc</th>
              <th>-2 miesiące</th>
              <th>-3 miesiące</th>
              <th>-4 miesiące</th>
              <th>-5 miesiecy</th>
              <th>-6 miesięcy</th>
            </tr>
            {rankData
              .filter((el) => el.type === "SKD")
              .map((rank, index) => (
                <>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{rank.name}</td>
                    <td>{rank.company}</td>
                    <td>{rank.counter}</td>
                    <td>
                      {rankDataA.filter(
                        (el) => el.type === "SKD" && el.name === rank.name
                      ).length > 0
                        ? rankDataA.filter(
                            (el) => el.type === "SKD" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataB.filter(
                        (el) => el.type === "SKD" && el.name === rank.name
                      ).length > 0
                        ? rankDataB.filter(
                            (el) => el.type === "SKD" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataC.filter(
                        (el) => el.type === "SKD" && el.name === rank.name
                      ).length > 0
                        ? rankDataC.filter(
                            (el) => el.type === "SKD" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataD.filter(
                        (el) => el.type === "SKD" && el.name === rank.name
                      ).length > 0
                        ? rankDataD.filter(
                            (el) => el.type === "SKD" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataE.filter(
                        (el) => el.type === "SKD" && el.name === rank.name
                      ).length > 0
                        ? rankDataE.filter(
                            (el) => el.type === "SKD" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataF.filter(
                        (el) => el.type === "SKD" && el.name === rank.name
                      ).length > 0
                        ? rankDataF.filter(
                            (el) => el.type === "SKD" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                  </tr>
                </>
              ))}
            <tr style={{ fontWeight: "900" }}>
              <td colSpan="3">SUMA</td>
              <td>{sum(rankData, "SKD", rankData)}</td>
              <td>{sum(rankDataA, "SKD", rankData)}</td>
              <td>{sum(rankDataB, "SKD", rankData)}</td>
              <td>{sum(rankDataC, "SKD", rankData)}</td>
              <td>{sum(rankDataD, "SKD", rankData)}</td>
              <td>{sum(rankDataE, "SKD", rankData)}</td>
              <td>{sum(rankDataF, "SKD", rankData)}</td>
            </tr>
          </table>
        </>
      )}
    </>
  );

  const dataM3 = (
    <>
      {rankData.filter((el) => el.type === "WIBOR").length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            Ilość leadów WIBOR przypisanych w zakresie
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość leadów:
              {sumCount(rankData.filter((el) => el.type === "WIBOR"))}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Handlowiec</th>
              <th>Oddział</th>
              <th>Liczba leadów</th>
              <th>-1 miesiąc</th>
              <th>-2 miesiące</th>
              <th>-3 miesiące</th>
              <th>-4 miesiące</th>
              <th>-5 miesiecy</th>
              <th>-6 miesięcy</th>
            </tr>
            {rankData
              .filter((el) => el.type === "WIBOR")
              .map((rank, index) => (
                <>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{rank.name}</td>
                    <td>{rank.company}</td>
                    <td>{rank.counter}</td>

                    <td>
                      {rankDataA.filter(
                        (el) => el.type === "WIBOR" && el.name === rank.name
                      ).length > 0
                        ? rankDataA.filter(
                            (el) => el.type === "WIBOR" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataB.filter(
                        (el) => el.type === "WIBOR" && el.name === rank.name
                      ).length > 0
                        ? rankDataB.filter(
                            (el) => el.type === "WIBOR" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataC.filter(
                        (el) => el.type === "WIBOR" && el.name === rank.name
                      ).length > 0
                        ? rankDataC.filter(
                            (el) => el.type === "WIBOR" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataD.filter(
                        (el) => el.type === "WIBOR" && el.name === rank.name
                      ).length > 0
                        ? rankDataD.filter(
                            (el) => el.type === "WIBOR" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataE.filter(
                        (el) => el.type === "WIBOR" && el.name === rank.name
                      ).length > 0
                        ? rankDataE.filter(
                            (el) => el.type === "WIBOR" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDataF.filter(
                        (el) => el.type === "WIBOR" && el.name === rank.name
                      ).length > 0
                        ? rankDataF.filter(
                            (el) => el.type === "WIBOR" && el.name === rank.name
                          )[0].counter
                        : "brak danych"}
                    </td>
                  </tr>
                </>
              ))}
            <tr style={{ fontWeight: "900" }}>
              <td colSpan="3">SUMA</td>
              <td>{sum(rankData, "WIBOR", rankData)}</td>
              <td>{sum(rankDataA, "WIBOR", rankData)}</td>
              <td>{sum(rankDataB, "WIBOR", rankData)}</td>
              <td>{sum(rankDataC, "WIBOR", rankData)}</td>
              <td>{sum(rankDataD, "WIBOR", rankData)}</td>
              <td>{sum(rankDataE, "WIBOR", rankData)}</td>
              <td>{sum(rankDataF, "WIBOR", rankData)}</td>
            </tr>
          </table>
        </>
      )}
    </>
  );

  const dataA1 = (
    <>
      {rankDepartData.filter((el) => el.department === "CHF").length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            Ilość umów CHF podpisanych w zakresie
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount2(
                rankDepartData.filter((el) => el.department === "CHF")
              )}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Źródło</th>
              <th>Liczba umów</th>
              <th>-1 miesiąc</th>
              <th>-2 miesiąc</th>
              <th>-3 miesiąc</th>
              <th>-4 miesiąc</th>
              <th>-5 miesiąc</th>
              <th>-6 miesiąc</th>
            </tr>
            {rankDepartData
              .filter((el) => el.department === "CHF")
              .map((rank, index) => (
                <>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{rank.source}</td>
                    <td>{rank.count}</td>
                    <td>
                      {rankDepartDataA.filter(
                        (el) =>
                          el.department === "CHF" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataA.filter(
                            (el) =>
                              el.department === "CHF" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataB.filter(
                        (el) =>
                          el.department === "CHF" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataB.filter(
                            (el) =>
                              el.department === "CHF" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataC.filter(
                        (el) =>
                          el.department === "CHF" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataC.filter(
                            (el) =>
                              el.department === "CHF" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataD.filter(
                        (el) =>
                          el.department === "CHF" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataD.filter(
                            (el) =>
                              el.department === "CHF" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataE.filter(
                        (el) =>
                          el.department === "CHF" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataE.filter(
                            (el) =>
                              el.department === "CHF" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataF.filter(
                        (el) =>
                          el.department === "CHF" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataF.filter(
                            (el) =>
                              el.department === "CHF" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                  </tr>
                </>
              ))}
            <tr style={{ fontWeight: "900" }}>
              <td colSpan="2">SUMA</td>
              <td>{sumDepart(rankDepartData, "CHF", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataA, "CHF", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataB, "CHF", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataC, "CHF", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataD, "CHF", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataE, "CHF", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataF, "CHF", rankDepartData)}</td>
            </tr>
          </table>
        </>
      )}
    </>
  );

  const dataA2 = (
    <>
      {rankDepartData.filter((el) => el.department === "SKD").length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            Ilość umów SKD podpisanych w zakresie
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount2(
                rankDepartData.filter((el) => el.department === "SKD")
              )}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Źródło</th>
              <th>Liczba umów</th>
              <th>-1 miesiąc</th>
              <th>-2 miesiąc</th>
              <th>-3 miesiąc</th>
              <th>-4 miesiąc</th>
              <th>-5 miesiąc</th>
              <th>-6 miesiąc</th>
            </tr>
            {rankDepartData
              .filter((el) => el.department === "SKD")
              .map((rank, index) => (
                <>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{rank.source}</td>
                    <td>{rank.count}</td>
                    <td>
                      {rankDepartDataA.filter(
                        (el) =>
                          el.department === "SKD" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataA.filter(
                            (el) =>
                              el.department === "SKD" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataB.filter(
                        (el) =>
                          el.department === "SKD" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataB.filter(
                            (el) =>
                              el.department === "SKD" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataC.filter(
                        (el) =>
                          el.department === "SKD" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataC.filter(
                            (el) =>
                              el.department === "SKD" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataD.filter(
                        (el) =>
                          el.department === "SKD" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataD.filter(
                            (el) =>
                              el.department === "SKD" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataE.filter(
                        (el) =>
                          el.department === "SKD" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataE.filter(
                            (el) =>
                              el.department === "SKD" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataF.filter(
                        (el) =>
                          el.department === "SKD" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataF.filter(
                            (el) =>
                              el.department === "SKD" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                  </tr>
                </>
              ))}
            <tr style={{ fontWeight: "900" }}>
              <td colSpan="2">SUMA</td>
              <td>{sumDepart(rankDepartData, "SKD", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataA, "SKD", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataB, "SKD", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataC, "SKD", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataD, "SKD", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataE, "SKD", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataF, "SKD", rankDepartData)}</td>
            </tr>
          </table>
        </>
      )}
    </>
  );

  const dataA3 = (
    <>
      {rankDepartData.filter((el) => el.department === "WIBOR").length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            Ilość umów WIBOR podpisanych w zakresie
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount2(
                rankDepartData.filter((el) => el.department === "WIBOR")
              )}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Źródło</th>
              <th>Liczba umów</th>
              <th>-1 miesiąc</th>
              <th>-2 miesiąc</th>
              <th>-3 miesiąc</th>
              <th>-4 miesiąc</th>
              <th>-5 miesiąc</th>
              <th>-6 miesiąc</th>
            </tr>
            {rankDepartData
              .filter((el) => el.department === "WIBOR")
              .map((rank, index) => (
                <>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{rank.source}</td>
                    <td>{rank.count}</td>
                    <td>
                      {rankDepartDataA.filter(
                        (el) =>
                          el.department === "WIBOR" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataA.filter(
                            (el) =>
                              el.department === "WIBOR" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataB.filter(
                        (el) =>
                          el.department === "WIBOR" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataB.filter(
                            (el) =>
                              el.department === "WIBOR" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataC.filter(
                        (el) =>
                          el.department === "WIBOR" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataC.filter(
                            (el) =>
                              el.department === "WIBOR" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataD.filter(
                        (el) =>
                          el.department === "WIBOR" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataD.filter(
                            (el) =>
                              el.department === "WIBOR" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataE.filter(
                        (el) =>
                          el.department === "WIBOR" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataE.filter(
                            (el) =>
                              el.department === "WIBOR" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                    <td>
                      {rankDepartDataF.filter(
                        (el) =>
                          el.department === "WIBOR" && el.source === rank.source
                      ).length > 0
                        ? rankDepartDataF.filter(
                            (el) =>
                              el.department === "WIBOR" &&
                              el.source === rank.source
                          )[0].count
                        : "brak danych"}
                    </td>
                  </tr>
                </>
              ))}
            <tr style={{ fontWeight: "900" }}>
              <td colSpan="2">SUMA</td>
              <td>{sumDepart(rankDepartData, "WIBOR", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataA, "WIBOR", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataB, "WIBOR", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataC, "WIBOR", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataD, "WIBOR", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataE, "WIBOR", rankDepartData)}</td>
              <td>{sumDepart(rankDepartDataF, "WIBOR", rankDepartData)}</td>
            </tr>
          </table>
        </>
      )}
    </>
  );

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div
            style={{
              backgroundColor: "white",
              top: "0",
              paddingTop: "5vh",
              paddingBottom: "3vh",
              paddingLeft: "2vw",
              paddingRight: "2vw",
            }}
          >
            <div
              style={{ display: "flex", justifyContent: "left", gap: "1vw" }}
            >
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "green",
                  borderColor: "green",
                  width: "180px",
                }}
                onClick={getData}
              >
                ODŚWIEŻ
              </button>
            </div>
          </div>

          <div style={{ display: "block", width: "50%" }}>
            <div
              style={{
                marginBottom: "1vh",
                width: "100%",
                textAlign: "left",
              }}
            >
              <label
                style={{
                  fontSize: ".6vw",
                  fontWeight: "600",
                  paddingLeft: "5px",
                }}
              >
                zakres dat
              </label>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  width: "100%",
                }}
                className="inputBox"
              >
                <div style={{ width: "45%" }}>
                  <label
                    style={{
                      fontSize: ".6vw",
                      paddingLeft: "5px",
                    }}
                  >
                    od
                  </label>
                  <input
                    style={{ height: "3vh", width: "100%" }}
                    type="date"
                    id="name"
                    name="name"
                    value={from}
                    onChange={(e) => setFrom(e.target.value)}
                  />
                </div>
                <div style={{ width: "45%" }}>
                  <label
                    style={{
                      fontSize: ".6vw",
                      paddingLeft: "5px",
                    }}
                  >
                    do
                  </label>
                  <input
                    style={{ height: "3vh", width: "100%" }}
                    type="date"
                    id="name"
                    name="name"
                    value={to}
                    onChange={(e) => setTo(e.target.value)}
                  />
                </div>
              </div>
              <div style={{ marginTop: "10px", textAlign: "left" }}>
                <button
                  style={{
                    backgroundColor: "navy",
                    border: "none",
                    color: "white",
                    textTransform: "uppercase",
                    fontWeight: "600",
                    borderRadius: "5px",
                  }}
                  id="clientsFilterButton"
                  className="paymentMenuButton"
                  onClick={getData}
                >
                  Pokaż
                </button>
              </div>
            </div>
          </div>

          <div
            style={{
              paddingLeft: "2vw",
              paddingBottom: "5vh",
            }}
          >
            {rankData.length === 0 ? (
              <p style={{ textAlign: "left" }}>BRAK STATYSTYK</p>
            ) : (
              <>
                {props.user.role === "admin" || props.user.role === "userplus"
                  ? dataM1
                  : ""}{" "}
                <br />
                {props.user.role === "admin" || props.user.role === "userplus"
                  ? dataS1
                  : ""}{" "}
                <br />
                {props.user.role === "admin" || props.user.role === "userplus"
                  ? dataM2
                  : ""}{" "}
                <br />
                {props.user.role === "admin" || props.user.role === "userplus"
                  ? dataS2
                  : ""}{" "}
                <br />
                {props.user.role === "admin" || props.user.role === "userplus"
                  ? dataM3
                  : ""}{" "}
                <br />
                {props.user.role === "admin" || props.user.role === "userplus"
                  ? dataS3
                  : ""}{" "}
                <br />
                {props.user.role === "admin" || props.user.role === "userplus"
                  ? dataA1
                  : ""}{" "}
                <br />
                {props.user.role === "admin" || props.user.role === "userplus"
                  ? dataA2
                  : ""}{" "}
                <br />
                {props.user.role === "admin" || props.user.role === "userplus"
                  ? dataA3
                  : ""}{" "}
                <br />
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default AppStatistics;
